<!-- <p class="editMat" *ngIf="isEdit">Edit Matter</p>
<p class="editMat" *ngIf="!isEdit">Create Matter</p> -->
   
<div class="hole">
<form class="formAl" [formGroup]="caseRegister" (ngSubmit)="onSubmit()">
   <!-- <span class="matlabel">Matter Info</span> -->
  <div class="row main stepitem">
    <div class="col-xs-12 col-sm-12 col-md-6">
      <!-- Form Component -->
      <!-- left row card 1 layout -->

      <div class="row containerbox containerboxone">
        <div class="col-sm-12">
          <div class="container">

            <!-- input field  -->
            <div class="form-group">
              <label for="title" class="fontbold">Case Title <span class="mandate">*</span>
              </label>
              <input formControlName="title" type="text" maxlength="250" (input)="restricttextSpace($event)" class="form-control textbox" id="title" name="title"
                [ngClass]="{'is-invalid':submitted && f.title.errors}">
              <div *ngIf="submitted && f.title.errors" class="invalid-feedback">
                <div *ngIf="f.title.errors.required">Case Title is required</div>
                <div *ngIf="f.title.errors.pattern"> Restricted Space at First Position </div>
              </div>
            </div>

            <!-- input field  -->
            <div class="form-group">
              <label for="title" class="fontbold">Case Number 
              </label>
              <input type="text" class="form-control textbox" maxlength="30"(input)="restricttextSpace($event)" id="caseNumbr" name="case_number"
                formControlName="case_number">
              <!-- <div *ngIf="submitted && f.case_number.errors" class="invalid-feedback">
                <div *ngIf="f.case_number.errors.required">Case Number is required</div>
                <div *ngIf="f.case_number.errors.pattern"> Restricted Space at First Position </div>
              </div> -->
            </div>

            <!-- calendor with icon -->
            <!-- <div class="form-group" *ngIf="showMore">
              <label for="filling date" class="fontbold">Date of Filling </label>
              <div class="input-group date" id="datepicker">
                <mat-form-field appearance="fill" class="form-group" style="width: 100%;">
                  <input matInput [matDatepicker]="picker" formControlName="date_of_filling" name="date_of_filling"
                    class="form-control " (click)="picker.open()" (dateChange)="addEvent('change', $event)" readonly>

                  <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                  <mat-datepicker #picker></mat-datepicker>
                  <!-- <div *ngIf="submitted && f.date_of_filling.errors" class="invalid-feedback">
                    <div *ngIf="f.date_of_filling.errors.required">Date is required</div>
                  </div> --
                </mat-form-field>
              </div>
            </div> -->
          <div class="form-group" *ngIf="showMore">
            <label class="fontbold">Date of Filing</label>
            <div class="custom-date-wrapper">
              <input #filingDp="bsDatepicker" bsDatepicker [bsConfig]="datePickerConfig" formControlName="date_of_filling"
                class="custom-input dpc" placeholder="Select Date" readonly (keydown)="$event.preventDefault()" (paste)="$event.preventDefault()" (keypress)="$event.preventDefault()" />
              <button class="icon-btn" type="button" (click)="filingDp.show(); $event.stopPropagation()">
                <img src="assets/img/cal-icon.svg" alt="calendar" />
              </button>
            </div>
          </div>

          
          <!-- <div class="form-group" *ngIf="showMore">
            <label class="fontbold">Date of Filing</label>
            <div class="custom-date-wrapper">
              <input #filingDp="bsDatepicker" bsDatepicker [bsConfig]="datePickerConfig" formControlName="date_of_filling"
                class="custom-input" placeholder="Select Date" readonly (click)="filingDp.show()" />
              <!-- Clear Button --
              <button *ngIf="caseRegister.get('date_of_filling')?.value" type="button" class="clear-btn"
                (click)="clearFilingDate($event)">✕</button>
              <button class="icon-btn" type="button" (click)="filingDp.show()">
                <img src="assets/img/cal-icon.svg" alt="calendar" />
              </button>
            </div>
          </div> -->

            <!-- text area -->
            <div class="form-group" *ngIf="showMore">
              <label for="filling date" class="fontbold">Description</label>
              <textarea rows="4" (input)="restricttextSpace($event)" cols="50" class="form-control textbox" formControlName="description"
                name="description" [ngClass]="{'is-invalid':submitted && f.description.errors}"
                maxlength="300" #description></textarea>
              <div *ngIf="submitted && f.description.errors" class="invalid-feedback">
                <div *ngIf="f.description.errors.required">description is required</div>
              </div>
              <div class="count-div">
                <div class="count-text" *ngIf="f.description">{{description.value.length}}/300</div>
              </div>
            </div>

            <!-- <div class="form-group">
              <label for="tags" class="fontbold">Matter Tags</label>
              <input type="text" (input)="restricttextSpace($event)" class="form-control textbox" id="tags" name="tags" placeholder="Type to add" formControlName="tags">
            </div> -->

            <add-tag [hidden]="!showMore" [editTagList]="editeMatterInfo?.tags || data?.tags"
                (childButtonEvent)="receiveTagMsgHandler($event)"></add-tag>
           
            <!-- additional details link -->
            <p *ngIf="!showMore" class="addInfo" (click)="showMore = !showMore">Additional Details</p>
            <!-- <p *ngIf="showMore" class="addInfo" (click)="showMore = !showMore">Show Less Details</p> -->
        </div>
        </div>
      </div> 
          
            


      <!-- ends here -->
    </div>

    <div class="col-xs-12 col-sm-12 col-md-6">
      <!-- component right side -->

      <div class="row containerbox formcontainer">
        <div class="col-sm-12">
          <div class="container">
            <!-- input field  -->
                         
            <!-- input field  -->
            <!-- <div class="form-group">
              <label for="title" class="fontbold">Matter Number <span class="mandate">*</span> </label>
              <input type="text" class="form-control textbox" maxlength="30"(input)="restricttextSpace($event)" id="caseNumbr" name="case_number"
                formControlName="case_number" [ngClass]="{'is-invalid':submitted && f.case_number.errors}">
              <div *ngIf="submitted && f.case_number.errors" class="invalid-feedback">
                <div *ngIf="f.case_number.errors.required">Matter Number is required</div>
                <div *ngIf="f.case_number.errors.pattern"> Restricted Space at First Position </div>
              </div>
            </div> -->

            <div class="form-group">
              <label class="fontbold">Matter Number <span class="mandate">*</span></label>
              <div class="input-with-icon">
                <input type="text" class="form-control textbox" maxlength="30" id="matterNumber" formControlName="matter_number"
                  (input)="restricttextSpace($event)" [ngClass]="{'is-invalid': submitted && f.matter_number.errors,'disabled-opacity': true}" readonly/>
                <i class="fa fa-info-circle info-icon" matTooltip="Automatically generated by the system" aria-hidden="true"></i>
              </div>
            
              <div *ngIf="submitted && f.matter_number.errors" class="invalid-feedback">
                <div *ngIf="f.matter_number.errors.required">Matter Number is required</div>
              </div>
            </div>
                        
            <!-- <div class="form-group">
              <label class="fontbold">Created Date </label>
              <div class="custom-date-wrapper">
                <input class="custom-input" [matDatepicker]="picker2" formControlName="created_date" readonly name="created_date" (click)="picker2.open()" placeholder="Select Date" />
                <button class="icon-btn" type="button" (click)="picker2.open()">
                  <mat-icon>calendar_today</mat-icon>
                </button>
                <mat-datepicker #picker2></mat-datepicker>
              </div>
             </div> -->
            <div class="form-group">
              <label class="fontbold">Created Date </label>
              <div class="custom-date-wrapper">
                <input #createdDp="bsDatepicker" bsDatepicker [bsConfig]="createdatePickerConfig" formControlName="created_date"
                  class="custom-input dpc" readonly (keydown)="$event.preventDefault()" (paste)="$event.preventDefault()" (keypress)="$event.preventDefault()" />
                <button class="icon-btn" type="button" (click)="createdDp.show(); $event.stopPropagation()">
                  <img src="assets/img/cal-icon.svg" alt="calendar" />
                </button>
              </div>
            </div>

            <!-- <div class="form-group" *ngIf="showMore">
              <label for="title" class="fontbold">Case Type </label>
              <select type="text" class="form-select member-name-text" formControlName="case_type" name="case_type" aria-describedby="add-con">
                <option value="" disabled selected>Select Case Type</option>
                <option *ngFor="let c of caseTypes" [value]="c">{{ c }}</option>
              </select>
            </div> -->
            <div class="form-group" *ngIf="showMore">
              <label for="title" class="fontbold">Case Type</label>
            
              <div class="custom-select">
                <div class="select-trigger" (click)="isOpen = !isOpen">
                  {{ selectedCaseType || 'Select Case Type' }}
                </div>
            
                <ul class="select-panel" *ngIf="isOpen">
                  <li *ngFor="let c of caseTypes" (click)="selectCaseType(c)">
                    {{ c }}
                  </li>
                </ul>
              </div>
            </div>

            
            <!-- input filled with icon -->
            <div class="form-group" *ngIf="showMore">
              <label for="court" class="fontbold">Court</label>
              <div class="input-group court" id="court_name">
                <input type="text" class="form-control textbox" (input)="restricttextSpace($event)" name="court_name" formControlName="court_name"
                  [ngClass]="{'is-invalid':submitted && f.court_name.errors}" />
                <img src="assets/img/court.svg" class="calimg calitem input-group-append courtimg">
                <div *ngIf="submitted && f.court_name.errors" class="invalid-feedback">
                  <div *ngIf="f.court_name.errors.required">Court is required</div>
                </div>
              </div>
            </div>
            <!-- input filled with icon -->
            <div class="form-group" *ngIf="showMore">
              <label for="judges" class="fontbold">Judge(s)</label>
              <div class="input-group judges" id="judges">
                <input type="text" class="form-control textbox" (input)="restricttextSpace($event)" name="judges" formControlName="judges"
                  [ngClass]="{'is-invalid':submitted && f.judges.errors}" />
                <img src="assets/img/judge.svg" class="calimg calitem input-group-append courtimg">
                <div *ngIf="submitted && f.judges.errors" class="invalid-feedback">
                  <div *ngIf="f.judges.errors.required">Judge is required</div>
                </div>
              </div>
            </div>
            <!-- input switch button -->
            <div class="row" *ngIf="showMore">
              <div class="col-sm-7">
                <p class="prioritytxt fontbold pad">Priority</p>
              </div>
              <div class="col-sm-5">
                <p class="prioritytxt fontbold pad">Status</p>
              </div>
            </div>
            <div class="row" *ngIf="showMore">
              <div class="col-sm-7">
                <!-- <div class="custom-control custom-radio">
                  <input id="High" type="radio" class="custom-control-input" value="High" name="priority"
                    formControlName="priority" [ngClass]="{'is-invalid':submitted && f.priority.errors}">
                  <label class="custom-control-label" for="male">High</label>
                </div> -->

                <!-- <div class="custom-control custom-radio">
                  <input id="Medium" type="radio" class="custom-control-input" value="Medium" name="priority"
                    formControlName="priority">
                  <label class="custom-control-label" for="female">Medium</label>
                </div> -->
                <!-- <div class="custom-control custom-radio">
                  <input id="Low" type="radio" class="custom-control-input" value="Low" name="priority"
                    formControlName="priority">
                  <label class="custom-control-label" for="female">Low</label>
                </div> -->

                <!-- <div *ngIf="submitted && f.priority.errors" class="invalid-feedback">
                  <div *ngIf="f.priority.errors.required">priority is required</div>
                </div> -->
                <ul class="nav nav-pills mb-3 btnaction" id="pills-tab" role="tablist">
                  <li class="nav-item" (click)="getPriority('High')">
                    <button  id="High"   name="priority"  [ngClass]="{'active': selectedPriority === 'High'}" class="selectprior optionhigh"
                      id="pills-home-tab" data-bs-toggle="pill" data-bs-target="#pills-home" type="button" role="tab"
                      aria-controls="pills-home" aria-selected="true">High</button>
                  </li>
                  <li class="nav-item" (click)="getPriority('Medium')">
                    <button  id="Medium" [ngClass]="{'active': selectedPriority === 'Medium'}" name="priority"  class="selectprior optionaling"
                      id="pills-profile-tab" data-bs-toggle="pill" data-bs-target="#pills-profile" type="button"
                      role="tab" aria-controls="pills-profile" aria-selected="false">Medium</button>
                  </li>
                  <li class="nav-item" (click)="getPriority('Low')">
                    <button id="Low"  [ngClass]="{'active': selectedPriority === 'Low'}" name="priority"  class=" selectprior optionlow"
                      id="pills-contact-tab" data-bs-toggle="pill" data-bs-target="#pills-contact" type="button"
                      role="tab" aria-controls="pills-contact" aria-selected="false">Low</button>
                  </li>
                </ul>
              </div>
              <div class="col-sm-5">
                <ul class="nav nav-pills mb-3 btnaction" id="pills-tab" role="tablist">
                  <li class="nav-item" (click)="getStatus('Active')">
                    <button class="selectprior optionhigh" [ngClass]="{'active': selectedStatus === 'Active'}" id="pills-home-tab" data-bs-toggle="pill"
                      data-bs-target="#pills-home" type="button" role="tab" aria-controls="pills-home"
                      aria-selected="true">Active</button>
                  </li>
                  <li class="nav-item" (click)="getStatus('Pending')">
                    <button class="selectprior optionaling pend" [ngClass]="{'active': selectedStatus === 'Pending'}" id="pills-profile-tab" data-bs-toggle="pill"
                      data-bs-target="#pills-profile" type="button" role="tab" aria-controls="pills-profile"
                      aria-selected="false">Pending</button>
                  </li>
                </ul>
              </div>
            </div>
            <!-- advoate file  -->
            <!-- add file -->
            <!-- <div class="form-group addfile">
              <div class="input-group court" id="judge">
                <input type="file" name="file" id="file" class="file">
                <input type="text" name="file-name " placeholder="apponente advicates" id="file-name" class="textbox form-control"
                  readonly="readonly">
                <input type="button" class="btnfile" value="ADD">
              </div>
            </div>

            <div formGroupName="memberDetail">
              <div class="form-group">
                <label for="title" class="fontbold">Name 
                </label>
                <input type="text" class="form-control textbox" id="member_name" name="member_name" placeholder="harvin name"
                  formControlName="member_name" [ngClass]="{'is-invalid':submitted && f.member_name.errors}">
                <div *ngIf="submitted && f.member_name.errors" class="invalid-feedback">
                  <div *ngIf="f.member_name.errors.required">Name is required</div>
                </div>
              </div>
              <div class="form-group">
                <label for="title" class="fontbold">Email Address
                </label>
                <input type="email" class="form-control textbox" id="email" name="email" placeholder="harvin name @123"
                  formControlName="name" [ngClass]="{'is-invalid':submitted && f.email.errors}">
                <div *ngIf="submitted && f.email.errors" class="invalid-feedback">
                  <div *ngIf="f.email.errors.required">Email is required</div>
                </div>
              </div>
              <div class="form-group">
                <label for="title" class="fontbold">Number
                </label>
                <input type="number" class="form-control textbox" id="phoneNumber" name="phoneNumber" placeholder="harvin name @123"
                  formControlName="phoneNumber" [ngClass]="{'is-invalid':submitted && f.phoneNumber.errors}">
                <div *ngIf="submitted && f.phoneNumber.errors" class="invalid-feedback">
                  <div *ngIf="f.phoneNumber.errors.required">phoneNumber is required</div>
                </div>
              </div>
              <div class="btnbox">
                
                <button type="submit" class="btn btn-default btnsave savecls" (click)="addOpponenteAdvicate()">Save</button>
          
              </div>
            </div> -->
            <!-- <add-adivicate *ngIf="showMore" [editAdvocatesList]="editeMatterInfo?.opponentAdvocates || data?.opponent_advocates"
             (childButtonEvent)="receiveAutoMsgHandler($event)" ></add-adivicate> -->
            <!-- <app-add-tag [editTagList]="editeMatterInfo?.tags || data?.tags"  
            (childButtonEvent)="receiveTagMsgHandler($event)" ></app-add-tag> -->

            <!-- end advocate -->
            <!-- pagination -->

          </div>
          <!-- ends here -->
        </div>
      </div>

    </div>

    <!-- Opponent field -->
    <add-adivicate *ngIf="showMore" [editAdvocatesList]="editeMatterInfo?.opponentAdvocates || data?.opponent_advocates"
       (childButtonEvent)="receiveAutoMsgHandler($event)" ></add-adivicate>

    <p *ngIf="showMore" class="addInfo" (click)="showMore = !showMore">Show Less Details</p>

    <div class="btnbox">
      <button type="button" class="btn btn-default btncancel orgc" (click)="OnCancel()">Cancel</button>
      <button type="button" class="btn btn-default btncancel" *ngIf="!caseRegister.invalid" (click)="OnSaveLater()">Save for Later</button>

      <!-- <button type="submit" class="btn btn-primary btnsave savecls" [ngClass]="{'disabled': isAddDisable === false}"> -->
        <button type="submit" class="btn btn-primary btnsave savecls infoBtn"
         [disabled]="caseRegister.invalid">
        <span>Save & Next</span>
        <!-- <span *ngIf="isEdit">Save</span> -->
      </button>
    </div>
  </div>
  <!-- grid ends here -->
</form>
</div>

<ngx-spinner  size="medium" type="ball-clip-rotate"></ngx-spinner>